import { useMutation, useQueryClient } from '@tanstack/react-query';
import { applicationApi } from '@src/apis/admin';
import type { ApplicationContactUpsertRequestModel, ApplicationBusinessType } from '@uniquegood/realworld-admin-interface';
import { normalizePhoneNumberForServer } from '@src/utils/phone';

/**
 * 채널 고객 정보 수정/생성 mutation
 */
export const useUpsertChannelContact = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ['upsertChannelContact'],
        mutationFn: async ({
            channelId,
            body,
        }: {
            channelId: string;
            body: {
                customerName: string;
                businessType: string;
                contactName: string;
                contactTitle: string;
                contactEmail: string;
                contactPhone: string;
                memo?: string;
            };
        }) => {
            // businessType을 ApplicationBusinessType으로 변환
            const businessTypeMap: Record<string, ApplicationBusinessType> = {
                'none': 'None',
                'company': 'General',
                'agency': 'Agency',
                'k12': 'School',
                'university': 'University',
                'public': 'Government',
                'library': 'Museum',
            };
            
            const apiBody: ApplicationContactUpsertRequestModel = {
                organizationName: body.customerName,
                businessType: businessTypeMap[body.businessType] || 'None',
                contactName: body.contactName,
                jobTitle: body.contactTitle || null,
                email: body.contactEmail || null,
                phone: normalizePhoneNumberForServer(body.contactPhone),
                memo: body.memo || null,
            };
            
            const { data } = await applicationApi.upsertApplicationContact(
                channelId,
                apiBody,
                undefined // x-rwd-api-version은 default value 사용
            );
            return { data, channelId };
        },
        onSuccess: (response) => {
            // 고객 정보 조회 쿼리 무효화하여 재조회 유도
            queryClient.invalidateQueries({ queryKey: ['channel-contact', response.channelId] });
            queryClient.invalidateQueries({ queryKey: ['channel-detail', response.channelId] });
            queryClient.invalidateQueries({ queryKey: ['channels'] });
        },
    });
};


